export enum CompetitionType {
  HOUROFCODE = "Hour of Code",
  CLUB = "Club",
  COMPETITION = "Competition",
}
